import plusTealIcon from "@assets/images/plus-teal.svg";
import saveIcon from "@assets/images/save-icon.svg";
import { Button, Paper } from "@material-ui/core";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import { ScgOrderStatus } from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface propsType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsType>(
  theme => ({
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      height: 88,
      alignItems: "center",
      boxShadow: "0px -8px 24px rgb(0 0 0 / 8%)",
      borderRadius: "20px 20px 0px 0px",
      padding: "0 3.2rem",
      "& .MuiButton-label": {
        fontWeight: "bold",
        "& img": {
          marginRight: "8px"
        }
      }
    },
    rightContainer: {
      display: "flex",
      alignItems: "center",
      "& .MuiButton-outlined": {
        marginRight: "1.6rem"
      }
    },
    leftContainer: {
      "& button": {
        marginRight: "1.6rem"
      }
    },
    menu: {
      padding: 0,
      position: "fixed",
      bottom: 0,
      right: 0,
      transition: "width 0.4s ease",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "0 2.4rem",
        paddingRight: props => `calc(2.4rem + ${props.bodyPaddingRight}px)`,
        width: props =>
          props.expandMenu
            ? `calc(100% - ${menuWidth}px)`
            : `calc(100% - ${shrunkMenuWidth}px)`
      }
    },
    total: {
      marginRight: "2.4rem"
    },
    btnConfirmOrder: {
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "1.8rem",
      lineHeight: "28px",
      height: 48,
      padding: "0 33px"
    }
  }),
  { name: "CreateOrderFooter" }
);

interface CreateOrderFooterProps {
  onOrder: (type: ScgOrderStatus) => void;
  onBack?: () => void;
  disabled?: boolean;
  hasValidationError?: boolean;
  total: string | number;
  dataSubmit: any;
}

const CreateOrderFooter: React.FC<CreateOrderFooterProps> = ({
  onOrder,
  onBack,
  disabled,
  hasValidationError,
  total
}) => {
  const [appState, _] = useAppState();
  const classes = useStyles({
    expandMenu: appState.expandMenu,
    bodyPaddingRight: appState.bodyPaddingRight
  });
  const intl = useIntl();

  return (
    <div className={classes.menu}>
      <Paper className={classes.wrapper}>
        <div className={classes.leftContainer}>
          <Button variant="outlined" color="secondary" disabled={disabled}>
            <FormattedMessage defaultMessage="ATP/CTP" />
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => onOrder(ScgOrderStatus.DRAFT)}
            disabled={disabled}
          >
            <img src={saveIcon} alt={""} />
            <FormattedMessage defaultMessage="บันทึกฉบับร่าง" />
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onBack}
            disabled={disabled}
          >
            <img src={plusTealIcon} alt={""} />
            <FormattedMessage defaultMessage="เพิ่มรายการสินค้า" />
          </Button>
        </div>

        <div className={classes.rightContainer}>
          <div className={classes.total}>
            <MyTypography variant="body3">
              {intl.formatMessage({
                defaultMessage: "ยอดสั่งซื้อทั้งหมด (บาท)"
              })}
            </MyTypography>
            <MyTypography variant="subtitle1">
              {total ? (
                <DecimalFormat
                  value={Number(total)}
                  isGrayDecimal={false}
                  countDecimal={2}
                />
              ) : (
                "0.00"
              )}
            </MyTypography>
          </div>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onOrder(ScgOrderStatus.CONFIRMED)}
            disabled={hasValidationError || disabled}
            className={classes.btnConfirmOrder}
          >
            <FormattedMessage defaultMessage="ยืนยันคำสั่งซื้อ" />
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default CreateOrderFooter;
